import React from 'react';
import { Table } from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { SessionTypes } from 'PointOfSale/modules/common/constants';

class LookUpResultTable extends React.Component {
  renderStudents() {
    const { profiles, onItemSelect } = this.props;
    return (
      <Table selectable striped basic="very">
        <Table.Body>
          {_.map(profiles, function(profile) {
            return (
              <Table.Row key={profile.Id} onClick={() => onItemSelect(profile)}>
                <Table.Cell width={8}>
                  {`${profile.FirstName} ${profile.LastName}` || '--'}{' '}
                </Table.Cell>
                <Table.Cell width={4}>
                  {profile.ServingNumber || '--'}
                </Table.Cell>
                <Table.Cell width={4}>{profile.Id || '--'}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    );
  }

  renderTeachers() {
    const { profiles: teachers = [], onItemSelect } = this.props;
    return (
      <Table selectable striped basic="very">
        <Table.Body>
          {teachers.map((teacher, index) => {
            return (
              <Table.Row
                key={`${teacher}_${index}`}
                onClick={() => onItemSelect(teacher)}
              >
                <Table.Cell width={8}>{`${teacher}` || '--'}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    );
  }

  render() {
    const { activeSession } = this.props;
    if (activeSession === SessionTypes.Queue) {
      return this.renderStudents();
    }

    if (activeSession === SessionTypes.Teacher) {
      return this.renderTeachers();
    }
    return 'Result strategy not defined.';
  }
}
LookUpResultTable.propTypes = {
  activeSession: PropTypes.string,
  profiles: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ),
  onItemSelect: PropTypes.func,
};

export default LookUpResultTable;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/component/LookUpResultTable.js